// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"b45150b0","402":"2553a063","466":"01d5e0d8","731":"7a934155","965":"723f8a3f","988":"76f6923a"}[chunkId] + ".chunk.js";
};